export default {
    USERS: '/users',
    RESOURCE_ACCOUNTS: '/resource-accounts',
    RESOURCE_ACCOUNTS_ENDPOINT: '/resourceAccounts',
    BUILDER: 'builder',
    CSVUSERS: 'csv-users',
    CSVRESOURCEACCOUNTS: 'csv-resource-accounts',
};
